import {
  getBannerMode,
  getBackground,
  getCoverImageWrapperStyle,
  getResolvedCoverImageUrl,
  getTextAlignValue,
  hasAddressContent,
} from "../../../utils/layoutUtils";
import EventAddressLink from "../../../components/EventAddressLink";

// ── SVG: Churrasco banner ─────────────────────────────────────────────────────

function Chama() {
  return (
    <svg width="70" height="130" viewBox="0 0 70 130" xmlns="http://www.w3.org/2000/svg">
      <path d="M35 125 Q8 104 10 76 Q12 54 4 32 Q22 50 20 68 Q25 50 22 24 Q38 42 34 62 Q40 44 36 16 Q54 36 50 58 Q56 40 52 28 Q65 48 60 70 Q62 88 35 125Z" fill="#f97316"/>
      <path d="M35 116 Q12 97 14 74 Q18 56 14 38 Q28 52 26 66 Q30 52 28 30 Q42 46 39 62 Q44 48 42 32 Q54 50 50 68 Q52 82 35 116Z" fill="#fbbf24"/>
      <path d="M35 104 Q18 88 20 74 Q24 60 22 48 Q32 56 31 68 Q34 58 33 46 Q42 56 40 68 Q42 80 35 104Z" fill="#fef9c3" opacity="0.9"/>
    </svg>
  );
}

function Churrasqueira() {
  return (
    <svg width="200" height="148" viewBox="0 0 200 148" xmlns="http://www.w3.org/2000/svg">
      <line x1="62" y1="100" x2="46" y2="146" stroke="#5c3317" strokeWidth="7" strokeLinecap="round"/>
      <line x1="138" y1="100" x2="154" y2="146" stroke="#5c3317" strokeWidth="7" strokeLinecap="round"/>
      <line x1="50" y1="126" x2="150" y2="126" stroke="#5c3317" strokeWidth="5" strokeLinecap="round"/>
      <ellipse cx="100" cy="92" rx="62" ry="18" fill="#3d1505"/>
      <rect x="38" y="78" width="124" height="20" rx="4" fill="#3d1505"/>
      <ellipse cx="100" cy="78" rx="62" ry="22" fill="#5c2700"/>
      <ellipse cx="100" cy="78" rx="56" ry="18" fill="none" stroke="#888" strokeWidth="2.5"/>
      <line x1="44" y1="78" x2="156" y2="78" stroke="#888" strokeWidth="2"/>
      <line x1="62" y1="62" x2="62" y2="94" stroke="#888" strokeWidth="2"/>
      <line x1="80" y1="61" x2="80" y2="95" stroke="#888" strokeWidth="2"/>
      <line x1="100" y1="60" x2="100" y2="96" stroke="#888" strokeWidth="2"/>
      <line x1="120" y1="61" x2="120" y2="95" stroke="#888" strokeWidth="2"/>
      <line x1="138" y1="62" x2="138" y2="94" stroke="#888" strokeWidth="2"/>
      <ellipse cx="100" cy="78" rx="50" ry="14" fill="#1a0800" opacity="0.85"/>
      <ellipse cx="78" cy="76" rx="14" ry="7" fill="#c2410c" opacity="0.9"/>
      <ellipse cx="104" cy="73" rx="16" ry="8" fill="#ea580c" opacity="0.85"/>
      <ellipse cx="126" cy="77" rx="12" ry="6" fill="#c2410c" opacity="0.9"/>
      <line x1="16" y1="68" x2="184" y2="72" stroke="#aaa" strokeWidth="4" strokeLinecap="round"/>
      <rect x="34" y="58" width="26" height="22" rx="6" fill="#b45309"/>
      <rect x="36" y="60" width="22" height="18" rx="5" fill="#d97706"/>
      <line x1="38" y1="67" x2="56" y2="67" stroke="#78350f" strokeWidth="2" strokeLinecap="round"/>
      <line x1="38" y1="72" x2="56" y2="72" stroke="#78350f" strokeWidth="2" strokeLinecap="round"/>
      <rect x="76" y="56" width="28" height="26" rx="6" fill="#7c2d12"/>
      <rect x="78" y="58" width="24" height="22" rx="5" fill="#9f1239"/>
      <line x1="80" y1="65" x2="100" y2="65" stroke="#4a0010" strokeWidth="2" strokeLinecap="round"/>
      <line x1="80" y1="71" x2="100" y2="71" stroke="#4a0010" strokeWidth="2" strokeLinecap="round"/>
      <rect x="120" y="57" width="26" height="24" rx="6" fill="#b45309"/>
      <rect x="122" y="59" width="22" height="20" rx="5" fill="#d97706"/>
      <line x1="124" y1="66" x2="142" y2="66" stroke="#78350f" strokeWidth="2" strokeLinecap="round"/>
      <line x1="124" y1="71" x2="142" y2="71" stroke="#78350f" strokeWidth="2" strokeLinecap="round"/>
      <rect x="152" y="58" width="24" height="22" rx="6" fill="#7c2d12"/>
      <rect x="154" y="60" width="20" height="18" rx="5" fill="#9f1239"/>
      <line x1="156" y1="67" x2="172" y2="67" stroke="#4a0010" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

function Caneca() {
  return (
    <svg width="72" height="110" viewBox="0 0 72 110" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="30" width="46" height="68" rx="5" fill="#b45309"/>
      <rect x="8" y="32" width="42" height="64" rx="4" fill="#f59e0b"/>
      <ellipse cx="29" cy="30" rx="23" ry="9" fill="white"/>
      <ellipse cx="15" cy="26" rx="10" ry="7" fill="white"/>
      <ellipse cx="29" cy="22" rx="12" ry="7" fill="white"/>
      <ellipse cx="44" cy="27" rx="9" ry="6" fill="white"/>
      <path d="M54 46 Q70 46 70 62 Q70 78 54 78" fill="none" stroke="#b45309" strokeWidth="9" strokeLinecap="round"/>
      <path d="M54 46 Q64 46 64 62 Q64 78 54 78" fill="none" stroke="#f59e0b" strokeWidth="5" strokeLinecap="round"/>
      <rect x="14" y="38" width="9" height="40" rx="4" fill="rgba(255,255,255,0.35)"/>
    </svg>
  );
}

function BolaFutebol({ stroke = "#111", fill = "#fff" }) {
  return (
    <svg width="88" height="88" viewBox="0 0 88 88" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="44" cy="44" r="39" fill={fill} stroke={stroke} strokeWidth="4"/>
      <path d="M44 25 L59 36 L53 54 L35 54 L29 36 Z" fill={stroke}/>
      <path d="M44 25 L44 8 M59 36 L78 30 M53 54 L64 72 M35 54 L24 72 M29 36 L10 30" stroke={stroke} strokeWidth="4" strokeLinecap="round"/>
      <path d="M29 36 L17 49 M59 36 L71 49 M35 54 L29 67 M53 54 L59 67" stroke={stroke} strokeWidth="3" strokeLinecap="round" opacity="0.75"/>
    </svg>
  );
}

function FootballBanner({
  primary = "#111",
  secondary = "#fff",
  accent = "#dc2626",
  line = "rgba(255,255,255,0.6)",
  background = null,
  collarColor = null,
}) {
  return (
    <div style={{ position: "relative", height: "100%", minHeight: 150, overflow: "hidden", background: primary }}>
      <div style={{
        position: "absolute",
        inset: 0,
        background: background ?? `linear-gradient(135deg, ${primary} 0%, ${primary} 48%, ${secondary} 48%, ${secondary} 54%, ${accent} 54%, ${accent} 100%)`,
        opacity: 0.92,
      }} />
      {collarColor && (
        <div style={{
          position: "absolute",
          top: -38,
          left: "50%",
          transform: "translateX(-50%)",
          width: 178,
          height: 80,
          background: collarColor,
          borderRadius: "0 0 90px 90px",
          boxShadow: "0 8px 18px rgba(0,0,0,0.22)",
        }} />
      )}
      <div style={{ position: "absolute", inset: 18, border: `2px solid ${line}`, borderRadius: 18, opacity: 0.7 }} />
      <div style={{ position: "absolute", top: 18, bottom: 18, left: "50%", borderLeft: `2px dashed ${line}`, opacity: 0.65 }} />
      <div style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: 96,
        height: 96,
        borderRadius: "50%",
        border: `2px solid ${line}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.18)",
        boxShadow: "0 14px 32px rgba(0,0,0,0.28)",
      }}>
        <BolaFutebol stroke={primary} fill={secondary} />
      </div>
    </div>
  );
}

const BADGE_IMAGE_SIZES = { P: 64, M: 88, G: 116, GG: 132 };

function resolvePublicImageUrl(url) {
  if (!url) return null;
  if (/^(https?:)?\/\//i.test(url) || url.startsWith("data:") || url.startsWith("blob:")) return url;
  return `${process.env.PUBLIC_URL}${url}`;
}

function buildHeaderTitleShadow(layoutConfig, defaultShadow) {
  const mode = layoutConfig?.headerTitleShadowMode ?? "default";
  if (mode === "none") return "none";
  if (mode !== "custom") return defaultShadow ?? "none";

  const x = layoutConfig?.headerTitleShadowOffsetX ?? 0;
  const y = layoutConfig?.headerTitleShadowOffsetY ?? 2;
  const blur = layoutConfig?.headerTitleShadowBlur ?? 8;
  const color = layoutConfig?.headerTitleShadowColor ?? "rgba(0,0,0,0.45)";
  return `${x}px ${y}px ${blur}px ${color}`;
}

// ── Banner assets ─────────────────────────────────────────────────────────────

const BANNER_ASSETS = {
  monica: require("../../../assets/images/turma-monica.jpg"),
  stitch: require("../../../assets/images/stitch.png"),
  frozen: require("../../../assets/images/frozen.png"),
};

function AddressLink({
  ...props
}) {
  return <EventAddressLink {...props} />;
}

// ── Palettes ──────────────────────────────────────────────────────────────────

export const PALETTES = {
  minimalista: {
    layoutType: "minimal",
    pageBg: "#f9f9f9",
    fontFamily: "'Poppins', sans-serif",
    maxWidth: 720,
    cardBg: "white",
    cardRadius: 16,
    cardShadow: "0 4px 24px rgba(0,0,0,0.08)",
    dateTextColor: "#444",
    addrTextColor: "#444",
    titleColor: "#111",
  },

  elegante: {
    layoutType: "elegant",
    pageBg: "#1a1a1a",
    fontFamily: "'Poppins', sans-serif",
    maxWidth: 720,
    preDeco: { symbol: "✦ ✦ ✦", symbolColor: "#c9a84c", subtitle: "Convite", subtitleColor: "#888" },
    cardBg: "#111",
    cardRadius: 4,
    cardBorder: "1px solid #333",
    cardShadow: "none",
    accentColor: "#c9a84c",
    textColor: "#f5f0e8",
    subTextColor: "#888",
    dividerColor: "#333",
    rsvpInnerBg: "#1a1a1a",
    postDeco: { symbol: "✦ ✦ ✦", color: "#555" },
  },

  moderno: {
    layoutType: "card",
    pageBg: "#f0f4ff",
    fontFamily: "'Poppins', sans-serif",
    maxWidth: 720,
    topDeco: null,
    cardBg: "transparent",
    cardRadius: 16,
    cardShadow: "none",
    headerBg: "#4f46e5",
    headerPadding: "40px 40px 28px",
    headerCorners: null,
    coverBorderColor: null,
    coverBorderWidth: 0,
    coverShadow: "none",
    coverPlaceholderBg: "rgba(255,255,255,0.2)",
    coverPlaceholderEmoji: "🎉",
    headerDescBg: "rgba(255,255,255,0.2)",
    headerDescColor: "rgba(255,255,255,0.9)",
    headerTitleColor: "white",
    headerTitleShadow: null,
    headerTitleSize: 36,
    hasBanner: false,
    dateStyle: "strip",
    dateStripBg: "#3730a3",
    dateDivider: "rgba(255,255,255,0.1)",
    dateLabelColor: "rgba(255,255,255,0.6)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.7)",
    dateWeekdayColor: "rgba(255,255,255,0.6)",
    dateTimeColor: "#a5b4fc",
    addrStyle: "strip",
    addrBg: "#3730a3",
    addrBorderTop: "1px solid rgba(255,255,255,0.1)",
    addrTextColor: "rgba(255,255,255,0.85)",
    rsvpBg: "white",
    rsvpPadding: "48px",
    rsvpShadow: "0 8px 32px rgba(79,70,229,0.12)",
    rsvpRadius: "0 0 16px 16px",
    bottomDeco: null,
  },

  festivo: {
    layoutType: "card",
    pageBg: "linear-gradient(135deg, #ff6b6b 0%, #ffd93d 50%, #6bcf7f 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "🎉 🎊 🎈", fontSize: 36, letterSpacing: 8 },
    cardBg: "white",
    cardRadius: 24,
    cardShadow: "0 20px 60px rgba(0,0,0,0.2)",
    headerBg: "linear-gradient(135deg, #ff6b6b, #ffd93d)",
    headerPadding: "32px 32px 24px",
    headerCorners: null,
    coverBorderColor: "white",
    coverBorderWidth: 6,
    coverShadow: "0 8px 24px rgba(0,0,0,0.2)",
    coverPlaceholderBg: "rgba(255,255,255,0.3)",
    coverPlaceholderEmoji: "🎂",
    headerDescBg: null,
    headerDescColor: "rgba(255,255,255,0.9)",
    headerTitleColor: "white",
    headerTitleShadow: "0 2px 8px rgba(0,0,0,0.2)",
    headerTitleSize: 28,
    hasBanner: false,
    dateStyle: "box",
    dateBoxBg: "#fff3cd",
    dateTextColor: "#333",
    dateTimeColor: "#666",
    addrStyle: "box",
    addrBoxBg: "#ffe0e0",
    addrTextColor: "#333",
    rsvpBg: "white",
    rsvpPadding: "24px 32px",
    bottomDeco: { text: "🌟 🎁 🌟", fontSize: 28, letterSpacing: 8 },
  },

  monica: {
    layoutType: "card",
    pageBg: "repeating-linear-gradient(45deg, #f4909a, #f4909a 40px, #fde68a 40px, #fde68a 80px)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: null,
    cardBg: "white",
    cardRadius: 20,
    cardBorder: "5px solid white",
    cardShadow: "0 20px 60px rgba(0,0,0,0.35)",
    headerBg: "#f4909a",
    headerPadding: "32px 32px 24px",
    headerCorners: { tl: "⭐", tr: "⭐" },
    coverBorderColor: "#fde68a",
    coverBorderWidth: 6,
    coverShadow: "0 8px 24px rgba(0,0,0,0.3)",
    coverPlaceholderBg: "#fde68a",
    coverPlaceholderEmoji: "🐰",
    headerDescBg: "#fde68a",
    headerDescColor: "#7c2d12",
    headerTitleColor: "white",
    headerTitleShadow: "2px 2px 0 rgba(0,0,0,0.2)",
    headerTitleSize: 28,
    hasBanner: true,
    bannerType: "image",
    bannerBg: "#fde68a",
    bannerHeight: 225,
    bannerAssetKey: "monica",
    bannerObjectFit: "cover",
    bannerObjectPosition: "center top",
    dateStyle: "strip",
    dateStripBg: "#fef3c7",
    dateDivider: "#f4909a",
    dateDividerWidth: 3,
    dateLabelColor: "#7c2d12",
    dateDayColor: "#7c2d12",
    dateMonthColor: "#7c2d12",
    dateWeekdayColor: "#92400e",
    dateTimeColor: "#c97b84",
    addrStyle: "strip",
    addrBg: "#2563eb",
    addrTextColor: "white",
    rsvpBg: "white",
    rsvpPadding: "32px 36px",
    bottomDeco: { text: "🌿 ⭐ 🍉", fontSize: 26, letterSpacing: 8 },
  },

  stitch: {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #023e8a 0%, #0077b6 45%, #00b4d8 80%, #90e0ef 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "🌺 🌊 🌴 🌊 🌺", fontSize: 30, letterSpacing: 8 },
    cardBg: "white",
    cardRadius: 24,
    cardShadow: "0 20px 60px rgba(2,62,138,0.45)",
    headerBg: "linear-gradient(135deg, #023e8a 0%, #0077b6 100%)",
    headerPadding: "36px 32px 28px",
    headerCorners: { tl: "🌺", tr: "🌺", bl: "🌊", br: "🌊" },
    coverBorderColor: "#90e0ef",
    coverBorderWidth: 6,
    coverShadow: "0 8px 24px rgba(0,0,0,0.35)",
    coverPlaceholderBg: "rgba(144,224,239,0.2)",
    coverPlaceholderEmoji: "🌺",
    headerDescBg: "rgba(144,224,239,0.2)",
    headerDescColor: "#caf0f8",
    headerDescBorder: "1px solid rgba(144,224,239,0.35)",
    headerTitleColor: "white",
    headerTitleShadow: "0 2px 12px rgba(0,0,0,0.3)",
    headerTitleSize: 30,
    hasBanner: true,
    bannerType: "image",
    bannerBg: "linear-gradient(180deg, #0077b6 0%, #0096c7 100%)",
    bannerHeight: 156,
    bannerAssetKey: "stitch",
    bannerObjectFit: "scale-down",
    bannerObjectPosition: "center top",
    dateStyle: "strip",
    dateStripBg: "#0096c7",
    dateDivider: "rgba(255,255,255,0.2)",
    dateLabelColor: "rgba(255,255,255,0.65)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.85)",
    dateWeekdayColor: "rgba(255,255,255,0.6)",
    dateTimeColor: "#90e0ef",
    addrStyle: "strip",
    addrBg: "#023e8a",
    addrBorderTop: "1px solid rgba(255,255,255,0.1)",
    addrTextColor: "rgba(144,224,239,0.9)",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "🌊 🌺 🌊", fontSize: 26, letterSpacing: 10 },
  },

  frozen: {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #062742 0%, #1b4965 40%, #4a9aba 80%, #caf0f8 100%)",
    fontFamily: "Georgia, serif",
    topDeco: {
      text: "❄ ❄ ❄",
      color: "rgba(202,240,248,0.85)",
      fontSize: 30,
      letterSpacing: 10,
      subtitle: "uma história mágica",
      subtitleColor: "rgba(202,240,248,0.6)",
    },
    cardBg: "rgba(255,255,255,0.97)",
    cardRadius: 4,
    cardShadow: "0 20px 60px rgba(6,39,66,0.55)",
    headerBg: "linear-gradient(180deg, #062742 0%, #1b4965 100%)",
    headerPadding: "40px 40px 32px",
    headerCorners: null,
    headerTopDeco: { text: "❄ ❄ ❄ ❄ ❄ ❄", color: "rgba(202,240,248,0.25)", fontSize: 13, letterSpacing: 14 },
    headerBottomDeco: { text: "✦ ✦ ✦", color: "rgba(202,240,248,0.5)", fontSize: 16, letterSpacing: 10 },
    coverBorderColor: "#caf0f8",
    coverBorderWidth: 5,
    coverShadow: "0 0 0 3px rgba(255,255,255,0.15), 0 8px 32px rgba(0,0,0,0.5)",
    coverPlaceholderBg: "rgba(202,240,248,0.15)",
    coverPlaceholderEmoji: "❄️",
    headerDescBg: null,
    headerDescColor: "#caf0f8",
    headerDescLetterSpacing: 4,
    headerTitleColor: "white",
    headerTitleShadow: null,
    headerTitleSize: 34,
    headerTitleWeight: 400,
    headerTitleLetterSpacing: 2,
    hasBanner: true,
    bannerType: "image",
    bannerBg: "linear-gradient(180deg, #1b4965 0%, #0077b6 100%)",
    bannerHeight: 493,
    bannerAssetKey: "frozen",
    bannerObjectFit: "cover",
    bannerObjectPosition: "center top",
    dateStyle: "strip",
    dateStripBg: "#4a9aba",
    dateDivider: "rgba(255,255,255,0.2)",
    dateLabelColor: "rgba(255,255,255,0.65)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.85)",
    dateWeekdayColor: "rgba(255,255,255,0.6)",
    dateTimeColor: "#caf0f8",
    addrStyle: "strip",
    addrBg: "#1b4965",
    addrBorderTop: "1px solid rgba(255,255,255,0.1)",
    addrTextColor: "rgba(202,240,248,0.85)",
    rsvpBg: "white",
    rsvpPadding: "40px 44px",
    bottomDeco: { text: "❄ ❄ ❄", color: "rgba(202,240,248,0.7)", fontSize: 26, letterSpacing: 12 },
  },

  churrasco: {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #1c0a00 0%, #7c2d12 55%, #c2410c 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "🔥 🥩 🔥", fontSize: 28, letterSpacing: 10 },
    cardBg: "white",
    cardRadius: 20,
    cardShadow: "0 20px 60px rgba(28,10,0,0.6)",
    headerBg: "linear-gradient(180deg, #1c0a00 0%, #7c2d12 100%)",
    headerPadding: "36px 32px 28px",
    headerCorners: { tl: "🔥", tr: "🔥" },
    coverBorderColor: "#f97316",
    coverBorderWidth: 6,
    coverShadow: "0 8px 28px rgba(0,0,0,0.45)",
    coverPlaceholderBg: "rgba(249,115,22,0.2)",
    coverPlaceholderEmoji: "🔥",
    headerDescBg: "#f97316",
    headerDescColor: "white",
    headerTitleColor: "white",
    headerTitleShadow: "0 2px 12px rgba(0,0,0,0.45)",
    headerTitleSize: 30,
    hasBanner: true,
    bannerType: "churrasco",
    bannerBg: "linear-gradient(180deg, #1c0a00 0%, #3d1505 100%)",
    bannerHeight: 152,
    dateStyle: "strip",
    dateStripBg: "#d97706",
    dateDivider: "rgba(255,255,255,0.25)",
    dateLabelColor: "rgba(255,255,255,0.7)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.9)",
    dateWeekdayColor: "rgba(255,255,255,0.65)",
    dateTimeColor: "white",
    addrStyle: "strip",
    addrBg: "#7c2d12",
    addrTextColor: "rgba(254,215,170,0.9)",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "🔥 🥩 🍺", fontSize: 26, letterSpacing: 10 },
  },

  futebol: {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #f8fafc 0%, #e5e7eb 52%, #111827 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "SÃO PAULO • CAMISA 1 • GOL", color: "#111827", fontSize: 12, letterSpacing: 5, mb: 18 },
    cardBg: "white",
    cardRadius: 18,
    cardShadow: "0 20px 60px rgba(15,23,42,0.35)",
    headerBg: "linear-gradient(180deg, #f8fafc 0%, #f8fafc 45%, #dc2626 45%, #dc2626 55%, #f8fafc 55%, #f8fafc 61%, #111827 61%, #111827 72%, #f8fafc 72%, #f8fafc 100%)",
    headerPadding: "36px 32px 28px",
    headerCorners: null,
    coverBorderColor: "#111827",
    coverBorderWidth: 5,
    coverShadow: "0 10px 28px rgba(0,0,0,0.32)",
    coverPlaceholderBg: "rgba(255,255,255,0.2)",
    coverPlaceholderEmoji: "⚽",
    headerDescBg: "rgba(17,17,17,0.76)",
    headerDescColor: "white",
    headerTitleColor: "#111111",
    headerTitleShadow: "0 2px 0 rgba(255,255,255,0.9), 0 8px 18px rgba(255,255,255,0.75)",
    headerTitleSize: 30,
    teamBadgeUrl: "/images/spfc-escudo.png",
    teamBadgeAlt: "Escudo SPFC",
    teamBadgeSize: 82,
    hasBanner: true,
    bannerType: "football",
    bannerHeight: 158,
    footballPrimary: "#111111",
    footballSecondary: "#f8fafc",
    footballAccent: "#dc2626",
    footballLine: "rgba(17,24,39,0.28)",
    footballBackground: "linear-gradient(180deg, #f8fafc 0%, #f8fafc 40%, #dc2626 40%, #dc2626 52%, #f8fafc 52%, #f8fafc 58%, #111827 58%, #111827 70%, #f8fafc 70%, #f8fafc 100%)",
    footballCollarColor: "#f8fafc",
    dateStyle: "strip",
    dateStripBg: "#111111",
    dateDivider: "rgba(255,255,255,0.22)",
    dateLabelColor: "rgba(255,255,255,0.65)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.86)",
    dateWeekdayColor: "rgba(255,255,255,0.68)",
    dateTimeColor: "#fca5a5",
    addrStyle: "strip",
    addrBg: "#dc2626",
    addrTextColor: "white",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "⚽ 🏆 ⚽", fontSize: 24, letterSpacing: 9 },
  },

  "futebol-tricolor": {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #08090c 0%, #f8fafc 48%, #dc2626 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "TRICOLOR • CAMISA 2 • GOL", color: "rgba(255,255,255,0.82)", fontSize: 12, letterSpacing: 5, mb: 18 },
    cardBg: "white",
    cardRadius: 18,
    cardShadow: "0 20px 60px rgba(17,17,17,0.44)",
    headerBg: "linear-gradient(180deg, rgba(248,250,252,0.96) 0 18px, rgba(248,250,252,0) 18px), repeating-linear-gradient(90deg, #f8fafc 0 14px, #dc2626 14px 36px, #f8fafc 36px 44px, #111827 44px 68px, #f8fafc 68px 76px)",
    headerPadding: "36px 32px 28px",
    headerCorners: null,
    coverBorderColor: "#111111",
    coverBorderWidth: 5,
    coverShadow: "0 10px 28px rgba(0,0,0,0.34)",
    coverPlaceholderBg: "rgba(255,255,255,0.2)",
    coverPlaceholderEmoji: "⚽",
    headerDescBg: "rgba(17,24,39,0.88)",
    headerDescColor: "white",
    headerTitleColor: "white",
    headerTitleShadow: "0 2px 0 #111827, 0 8px 18px rgba(0,0,0,0.5)",
    headerTitleSize: 30,
    teamBadgeUrl: "/images/spfc-escudo.png",
    teamBadgeAlt: "Escudo SPFC",
    teamBadgeSize: 76,
    hasBanner: true,
    bannerType: "football",
    bannerHeight: 158,
    footballPrimary: "#111827",
    footballSecondary: "#f8fafc",
    footballAccent: "#dc2626",
    footballLine: "rgba(255,255,255,0.78)",
    footballBackground: "repeating-linear-gradient(90deg, #f8fafc 0 18px, #dc2626 18px 44px, #f8fafc 44px 54px, #111827 54px 82px, #f8fafc 82px 92px)",
    footballCollarColor: "#f8fafc",
    dateStyle: "strip",
    dateStripBg: "#111111",
    dateDivider: "rgba(220,38,38,0.5)",
    dateLabelColor: "rgba(255,255,255,0.68)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.88)",
    dateWeekdayColor: "rgba(255,255,255,0.68)",
    dateTimeColor: "#fca5a5",
    addrStyle: "strip",
    addrBg: "#dc2626",
    addrTextColor: "white",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "⚽ 🔴 ⚫", fontSize: 24, letterSpacing: 9, color: "#111111" },
  },

  "futebol-cruzeiro": {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #254596 0%, #17347f 58%, #f8fafc 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "ESTRELAS • CAMPO • TORCIDA", color: "rgba(255,255,255,0.82)", fontSize: 12, letterSpacing: 5, mb: 18 },
    cardBg: "white",
    cardRadius: 18,
    cardShadow: "0 20px 60px rgba(37,69,150,0.42)",
    headerBg: "radial-gradient(circle at 50% 16%, rgba(255,255,255,0.2) 0 7px, transparent 8px), linear-gradient(135deg, #254596 0%, #17347f 68%, #f8fafc 68%, #ffffff 100%)",
    headerPadding: "36px 32px 28px",
    headerCorners: null,
    coverBorderColor: "#f8fafc",
    coverBorderWidth: 5,
    coverShadow: "0 10px 28px rgba(15,23,42,0.35)",
    coverPlaceholderBg: "rgba(255,255,255,0.2)",
    coverPlaceholderEmoji: "⚽",
    headerDescBg: "rgba(255,255,255,0.18)",
    headerDescColor: "white",
    headerDescBorder: "1px solid rgba(255,255,255,0.25)",
    headerTitleColor: "white",
    headerTitleShadow: "0 2px 12px rgba(15,23,42,0.45)",
    headerTitleSize: 30,
    teamBadgeUrl: "/images/cruzeiro-escudo.png",
    teamBadgeAlt: "Escudo Cruzeiro",
    teamBadgeSize: 82,
    hasBanner: true,
    bannerType: "football",
    bannerHeight: 158,
    footballPrimary: "#254596",
    footballSecondary: "#f8fafc",
    footballAccent: "#17347f",
    footballLine: "rgba(255,255,255,0.74)",
    footballBackground: "radial-gradient(circle at 50% 28%, #f8fafc 0 8px, transparent 9px), radial-gradient(circle at 34% 48%, #f8fafc 0 7px, transparent 8px), radial-gradient(circle at 66% 48%, #f8fafc 0 7px, transparent 8px), radial-gradient(circle at 50% 68%, #f8fafc 0 7px, transparent 8px), linear-gradient(135deg, #254596 0%, #17347f 100%)",
    dateStyle: "strip",
    dateStripBg: "#17347f",
    dateDivider: "rgba(255,255,255,0.22)",
    dateLabelColor: "rgba(255,255,255,0.7)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.86)",
    dateWeekdayColor: "rgba(255,255,255,0.68)",
    dateTimeColor: "#bfdbfe",
    addrStyle: "strip",
    addrBg: "#254596",
    addrTextColor: "rgba(255,255,255,0.9)",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "★ ⚽ ★", fontSize: 24, letterSpacing: 9, color: "#254596" },
  },

  "futebol-cruzeiro-raposa": {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #17347f 0%, #254596 50%, #e0f2fe 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "RAPOSA • ESTRELAS • GOL", color: "rgba(255,255,255,0.86)", fontSize: 12, letterSpacing: 5, mb: 18 },
    cardBg: "white",
    cardRadius: 18,
    cardShadow: "0 22px 64px rgba(14,71,161,0.44)",
    headerBg: "radial-gradient(circle at 20% 20%, rgba(14,165,233,0.35) 0 18%, transparent 19%), radial-gradient(circle at 78% 12%, rgba(255,255,255,0.16) 0 12%, transparent 13%), linear-gradient(135deg, #254596 0%, #17347f 62%, #0ea5e9 100%)",
    headerPadding: "34px 32px 28px",
    headerCorners: null,
    coverBorderColor: "#e0f2fe",
    coverBorderWidth: 5,
    coverShadow: "0 10px 28px rgba(15,23,42,0.35)",
    coverPlaceholderBg: "rgba(255,255,255,0.2)",
    coverPlaceholderEmoji: "⚽",
    headerDescBg: "rgba(224,242,254,0.16)",
    headerDescColor: "white",
    headerDescBorder: "1px solid rgba(255,255,255,0.28)",
    headerTitleColor: "white",
    headerTitleShadow: "0 2px 14px rgba(15,23,42,0.48)",
    headerTitleSize: 30,
    teamBadgeUrl: "/images/cruzeiro-raposa.png",
    teamBadgeAlt: "Cruzeiro Raposa",
    teamBadgeSize: 116,
    teamBadgeShadow: "drop-shadow(0 10px 16px rgba(15,23,42,0.42))",
    hasBanner: true,
    bannerType: "football",
    bannerHeight: 158,
    footballPrimary: "#254596",
    footballSecondary: "#f8fafc",
    footballAccent: "#0ea5e9",
    footballLine: "rgba(255,255,255,0.72)",
    footballBackground: "radial-gradient(circle at 50% 28%, #f8fafc 0 8px, transparent 9px), radial-gradient(circle at 34% 48%, #f8fafc 0 7px, transparent 8px), radial-gradient(circle at 66% 48%, #f8fafc 0 7px, transparent 8px), radial-gradient(circle at 50% 68%, #f8fafc 0 7px, transparent 8px), radial-gradient(circle at 20% 20%, rgba(14,165,233,0.45) 0 18%, transparent 19%), linear-gradient(135deg, #254596 0%, #17347f 72%, #0ea5e9 100%)",
    dateStyle: "strip",
    dateStripBg: "#17347f",
    dateDivider: "rgba(255,255,255,0.22)",
    dateLabelColor: "rgba(255,255,255,0.72)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.9)",
    dateWeekdayColor: "rgba(255,255,255,0.7)",
    dateTimeColor: "#bae6fd",
    addrStyle: "strip",
    addrBg: "#254596",
    addrTextColor: "rgba(255,255,255,0.92)",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "★ ⚽ ★", fontSize: 24, letterSpacing: 9, color: "#254596" },
  },

  "futebol-atletico": {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #050505 0%, #262626 56%, #f8fafc 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "ALVINEGRO • ESTRELA • GOL", color: "rgba(255,255,255,0.84)", fontSize: 12, letterSpacing: 5, mb: 18 },
    cardBg: "white",
    cardRadius: 18,
    cardShadow: "0 22px 64px rgba(3,7,18,0.5)",
    headerBg: "radial-gradient(circle at 50% 20px, #ffd000 0 10px, transparent 11px), repeating-linear-gradient(90deg, #111111 0 36px, #f8fafc 36px 72px)",
    headerPadding: "36px 32px 28px",
    headerCorners: null,
    coverBorderColor: "#ffd000",
    coverBorderWidth: 5,
    coverShadow: "0 10px 28px rgba(0,0,0,0.36)",
    coverPlaceholderBg: "rgba(255,255,255,0.2)",
    coverPlaceholderEmoji: "⚽",
    headerDescBg: "#ffd000",
    headerDescColor: "#111111",
    headerTitleColor: "#111111",
    headerTitleShadow: "0 1px 0 rgba(255,255,255,0.95), 0 6px 14px rgba(255,255,255,0.72)",
    headerTitleSize: 30,
    teamBadgeUrl: "/images/atletico-mg-escudo.png",
    teamBadgeAlt: "Escudo Atlético MG",
    teamBadgeSize: 88,
    teamBadgeShadow: "drop-shadow(0 10px 16px rgba(0,0,0,0.42))",
    hasBanner: true,
    bannerType: "football",
    bannerHeight: 158,
    footballPrimary: "#111111",
    footballSecondary: "#f8fafc",
    footballAccent: "#ffd000",
    footballLine: "rgba(255,255,255,0.72)",
    footballBackground: "radial-gradient(circle at 50% 24%, #ffd000 0 10px, transparent 11px), repeating-linear-gradient(90deg, #111111 0 36px, #f8fafc 36px 72px)",
    dateStyle: "strip",
    dateStripBg: "#111111",
    dateDivider: "rgba(255,208,0,0.34)",
    dateLabelColor: "rgba(255,255,255,0.68)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.86)",
    dateWeekdayColor: "rgba(255,255,255,0.68)",
    dateTimeColor: "#ffe45c",
    addrStyle: "strip",
    addrBg: "#2a2a2a",
    addrTextColor: "rgba(255,255,255,0.9)",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "★ ⚽ ★", fontSize: 24, letterSpacing: 9, color: "#111111" },
  },

  "futebol-atletico-homenagem": {
    layoutType: "card",
    pageBg: "linear-gradient(180deg, #ffffff 0%, #f4f4f5 48%, #111111 100%)",
    fontFamily: "'Poppins', sans-serif",
    topDeco: { text: "GALO • HOMENAGEM • GOL", color: "#111111", fontSize: 12, letterSpacing: 5, mb: 18 },
    cardBg: "white",
    cardRadius: 18,
    cardShadow: "0 22px 64px rgba(17,17,17,0.38)",
    headerBg: "linear-gradient(180deg, #ffffff 0%, #ffffff 54%, #111111 54%, #111111 61%, #ffffff 61%, #ffffff 68%, #111111 68%, #111111 75%, #ffffff 75%, #ffffff 100%)",
    headerPadding: "34px 32px 28px",
    headerCorners: null,
    coverBorderColor: "#111111",
    coverBorderWidth: 5,
    coverShadow: "0 10px 28px rgba(0,0,0,0.28)",
    coverPlaceholderBg: "rgba(17,17,17,0.08)",
    coverPlaceholderEmoji: "⚽",
    headerDescBg: "#ef3b25",
    headerDescColor: "white",
    headerTitleColor: "#111111",
    headerTitleShadow: "0 2px 0 rgba(255,255,255,0.9), 0 8px 18px rgba(255,255,255,0.7)",
    headerTitleSize: 30,
    teamBadgeUrl: "/images/atletico-mg-homenagem.png",
    teamBadgeAlt: "Galo Atlético MG",
    teamBadgeSize: 104,
    teamBadgeShadow: "drop-shadow(0 10px 14px rgba(17,17,17,0.28))",
    hasBanner: true,
    bannerType: "football",
    bannerHeight: 158,
    footballPrimary: "#111111",
    footballSecondary: "#f8fafc",
    footballAccent: "#ef3b25",
    footballLine: "rgba(17,17,17,0.22)",
    footballBackground: "linear-gradient(180deg, #ffffff 0%, #ffffff 46%, #111111 46%, #111111 54%, #ffffff 54%, #ffffff 62%, #111111 62%, #111111 70%, #ffffff 70%, #ffffff 100%)",
    dateStyle: "strip",
    dateStripBg: "#111111",
    dateDivider: "rgba(239,59,37,0.34)",
    dateLabelColor: "rgba(255,255,255,0.68)",
    dateDayColor: "white",
    dateMonthColor: "rgba(255,255,255,0.86)",
    dateWeekdayColor: "rgba(255,255,255,0.68)",
    dateTimeColor: "#ffc928",
    addrStyle: "strip",
    addrBg: "#2a2a2a",
    addrTextColor: "rgba(255,255,255,0.9)",
    rsvpBg: "white",
    rsvpPadding: "36px 40px",
    bottomDeco: { text: "⚽ 🔴 🟡", fontSize: 24, letterSpacing: 9, color: "#111111" },
  },
};

// ── Component ─────────────────────────────────────────────────────────────────

export default function TemplateUniversal({ evento, children, layoutConfig, templateId }) {
  const paletteId = layoutConfig?.paletteId ?? templateId ?? "festivo";
  const base = PALETTES[paletteId] ?? PALETTES.festivo;
  // Allow per-event palette overrides stored in layoutConfig.palette
  const p = layoutConfig?.palette ? { ...base, ...layoutConfig.palette } : base;

  const data    = new Date(evento.dataDoEvento);
  const dia     = data.toLocaleDateString("pt-BR", { day: "2-digit",    timeZone: "America/Sao_Paulo" });
  const mes     = data.toLocaleDateString("pt-BR", { month: "long",     timeZone: "America/Sao_Paulo" });
  const ano     = data.getFullYear();
  const diaSemana = data.toLocaleDateString("pt-BR", { weekday: "long", timeZone: "America/Sao_Paulo" });
  const dataFormatada = data.toLocaleDateString("pt-BR", {
    weekday: "long", day: "2-digit", month: "long", year: "numeric", timeZone: "America/Sao_Paulo",
  });
  const hora = data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", timeZone: "America/Sao_Paulo" });

  const mapsUrl    = evento.mapaUrl || `https://maps.google.com/?q=${encodeURIComponent(evento.localizacao)}`;
  const bgOverride = getBackground(layoutConfig);
  const showAddr   = (layoutConfig?.sections?.howToGet ?? true) &&
    (layoutConfig?.sections?.address ?? true) &&
    hasAddressContent(layoutConfig, evento.nomeEspaco, "pinText");
  const bannerUrl  = layoutConfig?.bannerUrl;
  const bannerMode = getBannerMode(layoutConfig);
  const shouldShowBanner = bannerMode !== "none" &&
    ((bannerMode === "custom" && !!bannerUrl) || (bannerMode === "default" && p.hasBanner));
  const coverImageUrl = getResolvedCoverImageUrl(layoutConfig, p.coverImageUrl ?? null);
  const headerBgImageUrl = layoutConfig?.headerBgImageUrl;
  const headerDescBg = layoutConfig?.headerDescBg ?? p.headerDescBg;
  const headerDescColor = layoutConfig?.headerDescColor ?? p.headerDescColor;
  const showHeaderTitle = layoutConfig?.headerTitleVisible !== false;
  const badgeImageMode = layoutConfig?.badgeImageMode ?? "default";
  const themeBadgeUrl = resolvePublicImageUrl(p.teamBadgeUrl);
  const badgeImageUrl = badgeImageMode === "none"
    ? null
    : badgeImageMode === "custom"
      ? layoutConfig?.badgeImageUrl || null
      : themeBadgeUrl;
  const badgeImagePlacement = layoutConfig?.badgeImagePlacement ?? "top";
  const badgeImageAlign = layoutConfig?.badgeImageAlign ?? "center";
  const badgeImageSize = layoutConfig?.badgeImageSize
    ? BADGE_IMAGE_SIZES[layoutConfig.badgeImageSize] ?? p.teamBadgeSize ?? 76
    : p.teamBadgeSize ?? 76;
  const headerTitleShadow = buildHeaderTitleShadow(layoutConfig, p.headerTitleShadow);
  const showTopDeco = layoutConfig?.topDecoVisible !== false;
  const topDecoAlign = getTextAlignValue(layoutConfig?.topDecoAlign ?? "center");
  const topDecoColor = layoutConfig?.topDecoColor ?? p.topDeco?.color ?? "inherit";
  const showBottomDeco = layoutConfig?.bottomDecoVisible !== false;
  const bottomDecoAlign = getTextAlignValue(layoutConfig?.bottomDecoAlign ?? "center");
  const bottomDecoColor = layoutConfig?.bottomDecoColor ?? p.bottomDeco?.color ?? "inherit";
  const dateGeneralColor = layoutConfig?.dateTextColor;
  const dateSideColor = layoutConfig?.dateDayColor ?? dateGeneralColor;
  const timeSideColor = layoutConfig?.dateTimeColor ?? dateGeneralColor;

  const _ci  = layoutConfig?.coverImage;
  const _ciW = (_ci?.shape === "square" ? { P: 140, M: 220, G: 320, GG: 360 } : { P: 90, M: 140, G: 200, GG: 225 })[_ci?.size ?? "M"] ?? 150;
  const _ciR = _ci?.shape === "square" ? 12 : "50%";
  const renderBadgeImage = (placement) => {
    if (!badgeImageUrl || badgeImagePlacement !== placement) return null;

    return (
      <img
        src={badgeImageUrl}
        alt={p.teamBadgeAlt ?? "Imagem do tema"}
        style={{
          display: "block",
          width: badgeImageSize,
          height: "auto",
          marginTop: placement === "afterTitle" ? 14 : 0,
          marginRight: badgeImageAlign === "left" || badgeImageAlign === "center" ? "auto" : 0,
          marginBottom: placement === "afterTitle" ? 0 : 14,
          marginLeft: badgeImageAlign === "right" || badgeImageAlign === "center" ? "auto" : 0,
          filter: p.teamBadgeShadow ?? "drop-shadow(0 8px 12px rgba(0,0,0,0.28))",
        }}
      />
    );
  };

  // ── Minimal layout (Minimalista) ───────────────────────────────────────────
  if (p.layoutType === "minimal") {
    const imgWrap = getCoverImageWrapperStyle(layoutConfig);
    return (
      <div style={{ minHeight: "100vh", background: bgOverride ?? p.pageBg, display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 20px", fontFamily: p.fontFamily }}>
        <div style={{ background: p.cardBg, borderRadius: p.cardRadius, maxWidth: p.maxWidth ?? 720, width: "100%", overflow: "hidden", boxShadow: p.cardShadow }}>
          {coverImageUrl && (
            <div style={{ padding: "36px 52px 0", display: "flex", justifyContent: "center" }}>
              <div style={imgWrap ?? { width: "100%", maxWidth: 360, borderRadius: 12, overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}>
                <img src={coverImageUrl} alt={evento.nome} style={{ width: "100%", height: "auto", display: "block" }} />
              </div>
            </div>
          )}
          <div style={{ padding: "48px 52px 36px" }}>
            {evento.descricao && (
              <p style={{ color: "#999", fontSize: 13, textTransform: "uppercase", letterSpacing: 2, marginBottom: 8 }}>{evento.descricao}</p>
            )}
            <h1 style={{ fontSize: 36, fontWeight: 700, color: p.titleColor ?? "#111", marginBottom: 28, fontFamily: "Georgia, serif" }}>{evento.nome}</h1>
            <div style={{ borderTop: "1px solid #eee", paddingTop: 28, display: "flex", flexDirection: "column", gap: 14 }}>
              <p style={{ color: p.dateTextColor ?? "#444", fontSize: 16 }}>
                📅 <span style={{ textTransform: "capitalize" }}>{dataFormatada}</span> às {hora}
              </p>
              {showAddr && (
                <AddressLink
                  layoutConfig={layoutConfig}
                  mapsUrl={mapsUrl}
                  endereco={evento.localizacao}
                  nomeEspaco={evento.nomeEspaco}
                  color={layoutConfig?.addrTextColor ?? p.addrTextColor ?? "#444"}
                  fontSize={16}
                  defaultMode="pinText"
                  defaultAlign="center"
                />
              )}
            </div>
          </div>
          <div style={{ padding: "0 52px 52px" }}>{children}</div>
        </div>
      </div>
    );
  }

  // ── Elegant layout (Elegante) ──────────────────────────────────────────────
  if (p.layoutType === "elegant") {
    const imgWrap = getCoverImageWrapperStyle(layoutConfig);
    return (
      <div style={{ minHeight: "100vh", background: bgOverride ?? p.pageBg, display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 20px", fontFamily: p.fontFamily }}>
        <div style={{ maxWidth: p.maxWidth ?? 720, width: "100%" }}>
          {p.preDeco && (
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <div style={{ color: p.preDeco.symbolColor, fontSize: 28, letterSpacing: 6 }}>{p.preDeco.symbol}</div>
              {p.preDeco.subtitle && (
                <p style={{ color: p.preDeco.subtitleColor, fontSize: 12, letterSpacing: 4, textTransform: "uppercase" }}>{p.preDeco.subtitle}</p>
              )}
            </div>
          )}
          <div style={{ background: p.cardBg, border: p.cardBorder ?? "none", borderRadius: p.cardRadius, overflow: "hidden" }}>
            {coverImageUrl && (
              <div style={{ padding: "40px 52px 0", display: "flex", justifyContent: "center" }}>
                <div style={imgWrap ?? { position: "relative", width: "100%", maxWidth: 360, borderRadius: 8, overflow: "hidden" }}>
                  <img src={coverImageUrl} alt={evento.nome} style={{ width: "100%", height: "auto", display: "block", opacity: 0.85 }} />
                  {!imgWrap && (
                    <div style={{ position: "absolute", inset: 0, background: `linear-gradient(to bottom, transparent 50%, ${p.cardBg})` }} />
                  )}
                </div>
              </div>
            )}
            <div style={{ padding: 52, textAlign: "center" }}>
              {evento.descricao && (
                <p style={{ color: p.accentColor, fontSize: 12, letterSpacing: 4, textTransform: "uppercase", marginBottom: 12 }}>{evento.descricao}</p>
              )}
              <h1 style={{ fontFamily: "Georgia, serif", fontSize: 40, color: p.textColor, fontWeight: 400, marginBottom: 36 }}>{evento.nome}</h1>
              <div style={{ borderTop: `1px solid ${p.dividerColor ?? "#333"}`, borderBottom: `1px solid ${p.dividerColor ?? "#333"}`, padding: "32px 0", margin: "0 0 36px" }}>
                <div style={{ color: p.accentColor, fontSize: 56, fontWeight: 300, lineHeight: 1 }}>{dia}</div>
                <div style={{ color: p.subTextColor, fontSize: 15, textTransform: "capitalize", marginTop: 6 }}>{mes} · {ano}</div>
                <div style={{ color: p.textColor, fontSize: 22, marginTop: 14 }}>{hora}</div>
              </div>
              {showAddr && (
                <AddressLink
                  layoutConfig={layoutConfig}
                  mapsUrl={mapsUrl}
                  endereco={evento.localizacao}
                  nomeEspaco={evento.nomeEspaco}
                  color={layoutConfig?.addrTextColor ?? p.subTextColor}
                  fontSize={15}
                  defaultMode="pinText"
                  defaultAlign="center"
                  style={{ marginBottom: 36, textTransform: "capitalize" }}
                />
              )}
              <div style={{ background: p.rsvpInnerBg ?? "#1a1a1a", borderRadius: 8, padding: 32, textAlign: "left" }}>
                {children}
              </div>
            </div>
          </div>
          {p.postDeco && (
            <div style={{ textAlign: "center", marginTop: 24, color: p.postDeco.color, fontSize: 12, letterSpacing: 3 }}>{p.postDeco.symbol}</div>
          )}
        </div>
      </div>
    );
  }

  // ── Card layout (all other themes) ────────────────────────────────────────
  return (
    <div style={{
      minHeight: "100vh",
      background: bgOverride ?? p.pageBg,
      display: "flex", flexDirection: "column", alignItems: "center",
      padding: "40px 10px",
      fontFamily: p.fontFamily,
    }}>
      <div style={{ maxWidth: p.maxWidth ?? 660, width: "100%" }}>

        {/* Top decoration */}
        {p.topDeco && showTopDeco && (
          <div style={{ textAlign: topDecoAlign, marginBottom: p.topDeco.mb ?? 16 }}>
            <div style={{ fontSize: p.topDeco.fontSize, letterSpacing: p.topDeco.letterSpacing, color: topDecoColor }}>
              {layoutConfig?.topDecoText ?? p.topDeco.text}
            </div>
            {p.topDeco.subtitle && (
              <div style={{
                color: p.topDeco.subtitleColor ?? "rgba(255,255,255,0.6)",
                fontSize: p.topDeco.subtitleFontSize ?? 12,
                letterSpacing: p.topDeco.subtitleLetterSpacing ?? 4,
                textTransform: "uppercase",
                marginTop: 6,
                fontFamily: "'Poppins', sans-serif",
              }}>
                {p.topDeco.subtitle}
              </div>
            )}
          </div>
        )}

        {/* Card */}
        <div style={{
          background: p.cardBg,
          borderRadius: p.cardRadius,
          overflow: "hidden",
          boxShadow: p.cardShadow,
          border: p.cardBorder ?? "none",
        }}>

          {/* Header */}
          <div style={{
            ...(headerBgImageUrl
              ? {
                  backgroundImage: `url(${headerBgImageUrl})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }
              : { background: layoutConfig?.headerBg ?? p.headerBg }),
            padding: p.headerPadding ?? "36px 32px 28px",
            textAlign: "center",
            position: "relative",
          }}>
            {p.headerCorners?.tl && <div style={{ position: "absolute", top: 14, left: 20, fontSize: 22 }}>{p.headerCorners.tl}</div>}
            {p.headerCorners?.tr && <div style={{ position: "absolute", top: 14, right: 20, fontSize: 22 }}>{p.headerCorners.tr}</div>}
            {p.headerCorners?.bl && <div style={{ position: "absolute", bottom: 14, left: 24, fontSize: 18, opacity: 0.7 }}>{p.headerCorners.bl}</div>}
            {p.headerCorners?.br && <div style={{ position: "absolute", bottom: 14, right: 24, fontSize: 18, opacity: 0.7 }}>{p.headerCorners.br}</div>}

            {p.headerTopDeco && (
              <div style={{ color: p.headerTopDeco.color, fontSize: p.headerTopDeco.fontSize, letterSpacing: p.headerTopDeco.letterSpacing, marginBottom: 16 }}>
                {p.headerTopDeco.text}
              </div>
            )}

            {renderBadgeImage("top")}

            {coverImageUrl && (
              <img src={coverImageUrl} alt={evento.nome} style={{
                display: "block",
                width: _ciW,
                height: _ci?.shape === "square" ? "auto" : _ciW,
                objectFit: "cover",
                borderRadius: _ciR,
                border: p.coverBorderWidth > 0 ? `${p.coverBorderWidth ?? 6}px solid ${p.coverBorderColor}` : "none",
                margin: "0 auto 16px",
                boxShadow: p.coverShadow ?? "0 8px 24px rgba(0,0,0,0.3)",
              }} />
            )}
            {renderBadgeImage("afterImage")}

            {evento.descricao && headerDescBg && (
              <div style={{
                display: "inline-block",
                background: headerDescBg,
                color: headerDescColor,
                padding: "4px 16px",
                borderRadius: 20,
                fontSize: 13,
                fontWeight: p.headerDescFontWeight ?? 600,
                marginBottom: 10,
                border: p.headerDescBorder ?? "none",
                letterSpacing: p.headerDescLetterSpacing ?? 0,
              }}>
                {evento.descricao}
              </div>
            )}
            {evento.descricao && !headerDescBg && (
              <p style={{ color: headerDescColor, fontSize: 14, fontWeight: 600, marginBottom: 6, letterSpacing: p.headerDescLetterSpacing ?? 0, textTransform: p.headerDescLetterSpacing ? "uppercase" : "none" }}>
                {evento.descricao}
              </p>
            )}
            {renderBadgeImage("beforeTitle")}

            {showHeaderTitle && (
              <h1 style={{
                color: layoutConfig?.headerTitleColor ?? p.headerTitleColor,
                fontSize: p.headerTitleSize ?? 30,
                fontWeight: p.headerTitleWeight ?? 800,
                lineHeight: 1.2,
                margin: 0,
                textShadow: headerTitleShadow,
                letterSpacing: p.headerTitleLetterSpacing ?? 0,
              }}>
                {evento.nome}
              </h1>
            )}
            {renderBadgeImage("afterTitle")}

            {p.headerBottomDeco && (
              <div style={{ marginTop: 18, color: p.headerBottomDeco.color, fontSize: p.headerBottomDeco.fontSize, letterSpacing: p.headerBottomDeco.letterSpacing }}>
                {p.headerBottomDeco.text}
              </div>
            )}
          </div>

          {/* Banner */}
          {shouldShowBanner && (
            bannerMode === "custom" && bannerUrl ? (
              <div style={{ background: p.bannerBg ?? p.headerBg ?? p.cardBg, height: "auto", width: "auto", overflow: "hidden" }}>
                <img
                  src={bannerUrl}
                  alt="Foto de capa"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </div>
            ) : p.bannerType === "churrasco" ? (
              <div style={{ background: p.bannerBg, overflow: "hidden", height: p.bannerHeight ?? 152 }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", gap: 12, padding: "8px 16px 0", height: "100%" }}>
                  <Chama />
                  <Churrasqueira />
                  <Caneca />
                </div>
              </div>
            ) : p.bannerType === "football" ? (
              <div style={{ overflow: "hidden", height: p.bannerHeight ?? 158 }}>
                <FootballBanner
                  primary={p.footballPrimary}
                  secondary={p.footballSecondary}
                  accent={p.footballAccent}
                  line={p.footballLine}
                  background={p.footballBackground}
                  collarColor={p.footballCollarColor}
                />
              </div>
            ) : (
              <div style={{ background: p.bannerBg, height: "auto", width: "auto" }}>
                <img
                  src={bannerUrl || BANNER_ASSETS[p.bannerAssetKey]}
                  alt="Banner"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </div>
            )
          )}

          {/* Date strip */}
          {p.dateStyle === "strip" && (
            <div style={{ background: layoutConfig?.dateBg ?? p.dateStripBg, display: "flex" }}>
              <div style={{
                flex: 1, padding: "18px 24px", textAlign: "center",
                borderRight: `${p.dateDividerWidth ?? 1}px solid ${layoutConfig?.dateDividerColor ?? layoutConfig?.addrDividerColor ?? p.dateDivider ?? "rgba(255,255,255,0.2)"}`,
              }}>
                <div style={{ color: dateSideColor ?? p.dateLabelColor, fontSize: 11, fontWeight: 700, letterSpacing: 2, marginBottom: 2 }}>📅 DATA</div>
                <div style={{ color: dateSideColor ?? p.dateDayColor, fontSize: 32, fontWeight: 800, lineHeight: 1 }}>{dia}</div>
                <div style={{ color: dateSideColor ?? p.dateMonthColor, fontSize: 13, textTransform: "capitalize" }}>{mes}</div>
                <div style={{ color: dateSideColor ?? p.dateWeekdayColor, fontSize: 12, textTransform: "capitalize" }}>{diaSemana}</div>
              </div>
              <div style={{ flex: 1, padding: "18px 24px", textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div style={{ color: timeSideColor ?? p.dateLabelColor, fontSize: 11, fontWeight: 700, letterSpacing: 2, marginBottom: 2 }}>⏰ HORA</div>
                <div style={{ color: timeSideColor ?? p.dateTimeColor, fontSize: 34, fontWeight: 800 }}>{hora}</div>
              </div>
            </div>
          )}

          {/* Address strip */}
          {p.addrStyle === "strip" && showAddr && (
            <div style={{
              background: layoutConfig?.addrBg ?? p.addrBg,
              padding: "16px 32px",
              borderTop: layoutConfig?.addrDividerColor
                ? `1px solid ${layoutConfig.addrDividerColor}`
                : (p.addrBorderTop ?? "none"),
            }}>
              <AddressLink
                layoutConfig={layoutConfig}
                mapsUrl={mapsUrl}
                endereco={evento.localizacao}
                nomeEspaco={evento.nomeEspaco}
                color={layoutConfig?.addrTextColor ?? p.addrTextColor}
                fontSize={14}
                fontWeight={500}
                iconSize={18}
                gap={12}
                defaultMode="pinText"
                defaultAlign="center"
              />
            </div>
          )}

          {/* RSVP section */}
          <div style={{
            background: layoutConfig?.rsvpBg ?? p.rsvpBg,
            color: layoutConfig?.rsvpTextColor ?? undefined,
            padding: p.rsvpPadding ?? "36px 40px",
            boxShadow: p.rsvpShadow ?? "none",
            borderRadius: p.rsvpRadius ?? 0,
          }}>
            {/* Date box (Festivo-style) */}
            {p.dateStyle === "box" && (
              <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
                <div style={{ background: p.dateBoxBg, borderRadius: 12, padding: "12px 16px", flex: 1, textAlign: "center" }}>
                  <div style={{ fontSize: 20 }}>📅</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: dateSideColor ?? p.dateTextColor ?? "#333", textTransform: "capitalize", marginTop: 4 }}>{dataFormatada}</div>
                  <div style={{ fontSize: 13, color: timeSideColor ?? p.dateTimeColor ?? "#666" }}>às {hora}</div>
                </div>
              </div>
            )}
            {/* Address box (Festivo-style) */}
            {p.addrStyle === "box" && showAddr && (
              <AddressLink
                layoutConfig={layoutConfig}
                mapsUrl={mapsUrl}
                endereco={evento.localizacao}
                nomeEspaco={evento.nomeEspaco}
                color={layoutConfig?.addrTextColor ?? p.addrTextColor ?? "#333"}
                fontSize={13}
                fontWeight={600}
                iconSize={20}
                gap={10}
                defaultMode="pinText"
                defaultAlign="center"
                style={{
                  background: p.addrBoxBg,
                  borderRadius: 12,
                  padding: "12px 16px",
                  marginBottom: 24,
                }}
              />
            )}
            {children}
          </div>

        </div>

        {/* Bottom decoration */}
        {p.bottomDeco && showBottomDeco && (
          <div style={{
            textAlign: bottomDecoAlign,
            marginTop: 20,
            fontSize: p.bottomDeco.fontSize,
            letterSpacing: p.bottomDeco.letterSpacing,
            color: bottomDecoColor,
          }}>
            {layoutConfig?.bottomDecoText ?? p.bottomDeco.text}
          </div>
        )}

      </div>
    </div>
  );
}
